export default "__VITE_ASSET__e3lv1jyb__"